/* KneeNova hero slideshow — slides the image track only; the copy stays put.
   Autoplay pauses on hover, on focus, and while the tab is hidden, and never
   starts at all when the visitor asks for reduced motion. */
(function(){
  document.querySelectorAll('[data-kn-hero]').forEach(function(root){
    var track = root.querySelector('[data-kn-track]');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-kn-go]'));
    var ctrl = root.querySelector('[data-kn-ctrl]');
    var prevBtn = root.querySelector('[data-kn-prev]');
    var nextBtn = root.querySelector('[data-kn-next]');
    var pauseBtn = root.querySelector('[data-kn-pause]');

    var delay = parseInt(root.getAttribute('data-autoplay'), 10) || 0;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var index = 0;
    var timer = null;
    var userPaused = false;

    function show(n){
      index = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      slides.forEach(function(s, k){ s.setAttribute('aria-hidden', k === index ? 'false' : 'true'); });
      dots.forEach(function(d, k){ d.setAttribute('aria-current', k === index ? 'true' : 'false'); });
    }
    function next(){ show(index + 1); }
    function prev(){ show(index - 1); }

    function stop(){ if (timer){ clearInterval(timer); timer = null; } }
    function start(){
      stop();
      if (!delay || reduce || userPaused) return;
      timer = setInterval(next, delay);
    }

    /* An explicit pause outranks hover/focus, so leaving the hero does not
       silently restart a slideshow the visitor chose to stop. */
    function setPaused(on){
      userPaused = on;
      if (pauseBtn){
        pauseBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', on ? 'Play slideshow' : 'Pause slideshow');
        var icPause = pauseBtn.querySelector('[data-ic-pause]');
        var icPlay = pauseBtn.querySelector('[data-ic-play]');
        if (icPause) icPause.hidden = on;
        if (icPlay) icPlay.hidden = !on;
      }
      if (on) { stop(); } else { start(); }
    }

    if (pauseBtn){
      if (!delay || reduce){
        pauseBtn.hidden = true;
      } else {
        pauseBtn.addEventListener('click', function(){ setPaused(!userPaused); });
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', function(){ prev(); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function(){ next(); start(); });
    dots.forEach(function(d){
      d.addEventListener('click', function(){ show(parseInt(d.getAttribute('data-kn-go'), 10)); start(); });
    });

    if (ctrl){
      ctrl.addEventListener('keydown', function(e){
        if (e.key === 'ArrowLeft'){ e.preventDefault(); prev(); start(); }
        if (e.key === 'ArrowRight'){ e.preventDefault(); next(); start(); }
      });
    }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function(){
      if (document.hidden) { stop(); } else { start(); }
    });

    var startX = null;
    track.addEventListener('touchstart', function(e){ startX = e.touches[0].clientX; stop(); }, { passive: true });
    track.addEventListener('touchend', function(e){
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 45){ if (dx < 0) { next(); } else { prev(); } }
      startX = null;
      start();
    });

    show(0);
    start();
  });
})();
